// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.dashboard_dashboard__2X4pa {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.dashboard_dashboardContain__1PN1x {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.dashboard_bodythemedark__tNqjU .dashboard_dashboardContain__1PN1x,
.dashboard_bodythemedark__tNqjU .dashboard_dashboard__2X4pa,
.dashboard_bodythemedark__tNqjU .dashboard_cont2__JTzw\\+ {
  background-Color: #0f1824;
}

.dashboard_top_header__7yObV .dashboard_top_header_inner__jX0wl {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.dashboard_cont2__JTzw\\+ {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.dashboard_subLink__1mmvU svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.dashboard_cst_vendr__HfXMV input {
  min-height: 35px !important;
}

.dashboard_cst_vendr__HfXMV .dashboard_form-control__bgAMo {
  background-color: #f5f6fa;
  border: none;
}

.dashboard_footer__KnaRi {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.dashboard_bodythemelight__85mlL {
  background-color: #fff;
  padding-top: 90px;
}

.dashboard_bodythemedark__tNqjU {
  background-color: #132337;
  padding-top: 90px;
}

.dashboard_bodythemeNew__zmUcj {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.dashboard_headerthemelight__DdGpF {
  background-color: #fff;
}

.dashboard_headerthemedark__2fO1i {
  background-color: #132337;
}

.dashboard_top_header__7yObV {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.dashboard_menuthemelight__dLcQx {
  background-color: #f5f6fa;
}

.dashboard_menuthemedark__z3mbP {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.dashboard_menulinklight__QWbE3 span {
  color: #666666 !important;
}

.dashboard_menulinklight__QWbE3 a {
  color: #CBCBCB !important;
}

.dashboard_menulinklight__QWbE3:hover span,
.dashboard_menulinklight__QWbE3:hover a {
  color: #fff !important;
}

.dashboard_menulinkdarkSelected__UpGSV {
  background-color: #1c2e45;
  color: #3b82f6;
}

.dashboard_menuthemelight__dLcQx .dashboard_menulinklightSelected__uaXyO {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.dashboard_menulinkdark__jiiRQ {
  color: #92afd3 !important;
}

.dashboard_menulinklight__QWbE3:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.dashboard_menulinklight__QWbE3 .dashboard_sub_arrow__poJaq svg path {
  stroke: #CBCBCB !important;
}

.dashboard_menulinklight__QWbE3:hover .dashboard_sub_arrow__poJaq svg path {
  stroke: #fff !important;
}

.dashboard_menulinkdark__jiiRQ .dashboard_sub_arrow__poJaq svg path {
  stroke: #92afd3 !important;
}

.dashboard_menulinkdark__jiiRQ:hover .dashboard_sub_arrow__poJaq svg path {
  stroke: #fff !important;
}

.dashboard_menulinklight__QWbE3:hover svg path,
.dashboard_menulinklightSelected__uaXyO svg path {
  fill: #fff !important;
}

.dashboard_menulinkdark__jiiRQ:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.dashboard_headinglight__8Gl0v {
  color: #60677e;
}

.dashboard_headingdark__X4j2I {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.dashboard_searchboxlight__A7x-y {
  background-color: #fff;
  border: none;
}

.dashboard_searchboxdark__GuhA\\+ {
  background-color: #132337;
  color: #fff;
  border: none;
}

.dashboard_searchboxdark__GuhA\\+::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.dashboard_tableheadlight__VLx7S {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.dashboard_tableheadlight__VLx7S th {
  color: #fff;
}

thead .dashboard_tableheadlight__VLx7S th:first-child,
thead .dashboard_tableheaddark__odkCt th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .dashboard_tableheadlight__VLx7S th:last-child,
thead .dashboard_tableheaddark__odkCt th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.dashboard_table__zohyZ.dashboard_table-borderless__cL77O {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.dashboard_tableheaddark__odkCt {
  background-color: #132337;
  color: #fff;
}

.dashboard_table-borderless__cL77O tr:nth-child(even) {
  background-color: #F9FAFB;
}

.dashboard_table-borderless__cL77O .dashboard_left-section__4nEtb {
  padding-top: 10px;
}

.dashboard_tablebodylight__xtFsA td,
.dashboard_tablebodydark__5Jm0I td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.dashboard_tablebodylight__xtFsA {
  background-color: #fff;
}
.dashboard_tablebodylight__xtFsA:hover {
  background-color: #fff;
  cursor: auto;
}
.dashboard_tablebodylight__xtFsA p {
  line-height: 24px;
}

.dashboard_tablebodydark__5Jm0I {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.dashboard_tablebodydark__5Jm0I:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.dashboard_paginationlight__O9iTx {
  color: #60677e !important;
  font-size: 13px !important;
}

.dashboard_paginationdark__6A2kS {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.dashboard_formthemelight__BpAw2 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.dashboard_formthemedark__qFGY5 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.dashboard_formthemedark__qFGY5 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.dashboard_viewformlight__67llm {
  background-color: #f3f6f9;
}

.dashboard_permissionboxlight__k6c2l {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.dashboard_permissionboxdark__MoLbm {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.dashboard_errormsgclr__7ulBC {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.dashboard_graphclrlight__qWxEk {
  background-color: #fff;
}

.dashboard_graphclrdark__D1mje {
  background-color: #132337;
}

/* 
Counter theme
*/
#dashboard_card1bglight__wOTeF {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#dashboard_card1bgdark__CyjLA {
  background: #392f28;
}

#dashboard_card2bglight__9gJ\\+Q {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#dashboard_card2bgdark__rY7Kf {
  background: #1c3238;
}

#dashboard_card3bglight__AcfyJ {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#dashboard_card3bgdark__duwdO {
  background: #3a2434;
}

#dashboard_card4bglight__L0oy1 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#dashboard_card4bgdark__8dScE {
  background: #2f264f;
}

#dashboard_card1bgdark__CyjLA a,
#dashboard_card1bgdark__CyjLA p,
#dashboard_card2bgdark__rY7Kf a,
#dashboard_card2bgdark__rY7Kf p,
#dashboard_card3bgdark__duwdO a,
#dashboard_card3bgdark__duwdO p,
#dashboard_card4bgdark__8dScE a,
#dashboard_card4bgdark__8dScE p {
  color: #fff;
}

/* 
Action button theme
*/
.dashboard_actionbtnlight__OV3fZ {
  color: rgba(70, 71, 91, 0.8705882353);
}

.dashboard_actionbtndark__Ym9uB {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.dashboard_profiledropdownlight__DeK28 {
  background-color: #fff;
}

.dashboard_profiledropdowndark__H2uVI {
  background-color: #151521;
}

.dashboard_settingsection__kqMt9 #dashboard_addform__1o\\+ax.dashboard_formthemedark__qFGY5 .dashboard_savebtn__S908b {
  background-color: #3b82f6;
  color: #fff;
}

#dashboard_addform__1o\\+ax.dashboard_formthemedark__qFGY5 .dashboard_savebtn__S908b {
  background-color: #3b82f6;
  color: #fff;
}

.dashboard_profile_conatiner__6npgU {
  border-radius: 5px !important;
}

.dashboard_bodythemedark__tNqjU .dashboard_ag-theme-alpine__z7eG5 .dashboard_ag-row__AN4Wr {
  background: #000 !important;
}

.dashboard_bodythemedark__tNqjU .dashboard_formbtn__4fnEY {
  background-color: #3b82f6;
}

.dashboard_bodythemedark__tNqjU .dashboard_formbtn__4fnEY:hover {
  background-color: #2563eb;
}

.dashboard_bodythemedark__tNqjU .dashboard_resetbtn__ZiZhn {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.dashboard_bodythemedark__tNqjU .dashboard_resetbtn__ZiZhn:hover {
  background-color: #3b82f6;
}

.dashboard_headingdark__X4j2I span {
  background-color: #132337;
}

.dashboard_resetbtn__ZiZhn {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.dashboard_resetbtn__ZiZhn:hover,
.dashboard_resetbtn__ZiZhn:active,
.dashboard_resetbtn__ZiZhn:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.dashboard_addBtn__tARHS {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.dashboard_addDltBtn__dsT6F {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.dashboard_addbtnlight__Y6MkE {
  background-color: #38A169;
}

.dashboard_addbtndark__DLUUQ {
  background-color: #3b82f6;
}

.dashboard_addbtndark__DLUUQ:hover {
  background-color: #2563eb;
}

.dashboard_formthemedark__qFGY5 label {
  color: #92afd3;
}

.dashboard_addBtn__tARHS svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.dashboard_addBtn__tARHS:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.dashboard_cust_addBtn__JN2C2.dashboard_addBtn__tARHS svg {
  top: 2px;
}

.dashboard_deleteBtn__1orlI {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.dashboard_deleteBtn__1orlI {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.dashboard_deleteBtn__1orlI:active,
.dashboard_deleteBtn__1orlI:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.dashboard_deleteBtn__1orlI svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.dashboard_deleteBtn__1orlI:hover,
.dashboard_deleteBtn__1orlI:active,
.dashboard_deleteBtn__1orlI:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.dashboard_confirmBtn__Aj0HH {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.dashboard_confirmBtn__Aj0HH:hover,
.dashboard_confirmBtn__Aj0HH:active,
.dashboard_confirmBtn__Aj0HH:focus {
  background-color: #0f1824 !important;
}

.dashboard_confirmBtn__Aj0HH svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.dashboard_delPopContainer__bRFtb .dashboard_modal-body__pICNd {
  padding: 35px;
  text-align: center;
}

.dashboard_delPopContainer__bRFtb .dashboard_delet_icon__79xF7 {
  margin-bottom: 11px;
}

.dashboard_delPopContainer__bRFtb p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.dashboard_arrowback__74CQ1 svg {
  fill: #000;
}

.dashboard_bodythemedark__tNqjU .dashboard_arrowback__74CQ1 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.dashboard_bodythemedark__tNqjU .dashboard_arrowback__74CQ1 svg {
  fill: #3b82f6;
}

.dashboard_bodythemedark__tNqjU .dashboard_drpdwn_btn__L8wHP {
  background-color: #132337;
}

.dashboard_bodythemedark__tNqjU .dashboard_empname__mqYmp {
  color: #92afd3 !important;
}

.dashboard_bodythemedark__tNqjU .dashboard_navitemli__t6lEK a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.dashboard_bodythemedark__tNqjU .dashboard_tabnavli__HzoDT a.dashboard_settingsgeneral__YZDSd,
.dashboard_bodythemedark__tNqjU .dashboard_tabnavli__HzoDT a.dashboard_settingslinks__MpNF6:hover {
  background-color: #3b82f6;
  color: #fff;
}

.dashboard_bodythemedark__tNqjU .dashboard_tabnavli__HzoDT a.dashboard_settingslinks__MpNF6 {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG {
  background-color: #1c2e45;
  color: #fff;
}

.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG ul li a,
.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG .dashboard_dropdown_item__JKrCf,
.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG .dashboard_dropdown_item__JKrCf h5 {
  color: #fff;
}

.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG ul li a:hover,
.dashboard_headerthemedark__2fO1i .dashboard_dropdown_menu_contain__8MeLG .dashboard_dropdown_item__JKrCf:hover {
  background-color: #132337;
  color: #fff;
}

.dashboard_dropdown_item__JKrCf:active {
  background-color: #F5F6FA;
}

.dashboard_profile_arrrow_dwn__zj21K {
  stroke: #132337;
}

.dashboard_headerthemedark__2fO1i .dashboard_profile_arrrow_dwn__zj21K {
  stroke: #fff;
}

.dashboard_dateinputbox1__UEice input,
.dashboard_dateinputbox1__UEice span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.dashboard_delPopContainer__bRFtb .dashboard_modal-content__8gJsZ {
  border-radius: 10px;
  min-width: 399px;
}

.dashboard_larg_model__GfhPs .dashboard_modal-dialog__6Mq2P {
  max-width: 100% !important;
}

.dashboard_larg_model__GfhPs .dashboard_modal-content__8gJsZ {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.dashboard_larg_model__GfhPs .dashboard_modal-header__3Zdve {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .dashboard_btn-primary__0X7d8:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.dashboard_form-select__M5y6t {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .dashboard_CustomTable_tableheadlight__HuHZw__IF0OD th:first-child,
thead .dashboard_CustomTable_tableheaddark__nwqb4__38ezU th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .dashboard_tableheadlight__VLx7S th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .dashboard_dashboard__2X4pa {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .dashboard_cont2__JTzw\\+ {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .dashboard_sectionright__\\+CbsA {
    float: unset !important;
  }
  .dashboard_dashboard__2X4pa {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .dashboard_cont2__JTzw\\+ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .dashboard_bodythemelight__85mlL,
.dashboard_bodythemedark__tNqjU {
    padding-top: 110px;
  }
  .dashboard_delPopContainer__bRFtb .dashboard_modal-content__8gJsZ {
    min-width: 100%;
  }
  .dashboard_delPopContainer__bRFtb .dashboard_modal-body__pICNd {
    padding: 15px;
  }
  .dashboard_larg_model__GfhPs .dashboard_modal-content__8gJsZ {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .dashboard_exer_modal_contain__LM7JH .dashboard_modal-dialog__6Mq2P {
    max-width: 1055px;
  }
  .dashboard_delPopContainer__bRFtb .dashboard_modal-dialog__6Mq2P {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.dashboard_active_show_outer__B2-gQ h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .dashboard_active_show_outer__B2-gQ h2 {
    margin-top: 15px;
  }
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 {
  width: 100%;
  display: block;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_img__yaAM1 {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_img__yaAM1 {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_img__yaAM1 img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q {
  width: 100%;
  display: block;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q svg {
  flex-shrink: 0;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q .dashboard_act_box_bdg__jdTPH {
  width: 100%;
  margin-bottom: 12px;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q .dashboard_act_box_bdg__jdTPH span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q .dashboard_act_box_bdg__jdTPH .dashboard_sold__w3d\\+y {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.dashboard_active_show_outer__B2-gQ .dashboard_active_show_inner__7pO90 .dashboard_act_box_cnt__0wa8Q p .dashboard_timezone_code_pill__b-aV2 {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#dashboard_attent_details_row1__\\+ZT33 {
  margin-bottom: 0 !important;
}

.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_l__aLxIj img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 {
  flex: 1 1;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE .dashboard_attent_details_row_box__2R8iC {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE .dashboard_attent_details_row_box__2R8iC {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE .dashboard_attent_details_row_box__2R8iC {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE .dashboard_attent_details_row_box__2R8iC p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row__oIfeE .dashboard_attent_details_row_box__2R8iC h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row_last__rzty5 {
  margin-bottom: 0px !important;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row_last__rzty5.dashboard_interesting_fact__t\\+aAo {
  padding-top: 30px;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row_last__rzty5.dashboard_interesting_fact__t\\+aAo .dashboard_attent_details_row_box__2R8iC {
  width: 100%;
}
.dashboard_attent_details__mNmuQ .dashboard_attent_details_inner__EfTNs .dashboard_attent_details_inner_r__QqrY1 .dashboard_attent_details_row_last__rzty5.dashboard_interesting_fact__t\\+aAo .dashboard_attent_details_row_box__2R8iC h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.dashboard_showbox_sec__-3t21 {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .dashboard_showbox_sec__-3t21 {
    justify-content: center;
  }
}

.dashboard_show_box_main__SfkQx {
  margin: 10px 0px;
}
.dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+ {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+ {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+ {
    min-height: 500px;
    width: 200px !important;
  }
}
.dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+ img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+ img {
    max-height: 300px !important;
  }
}
.dashboard_show_box_main__SfkQx .dashboard_show_box__6V0g\\+:last-child {
  margin-right: 0px !important;
}
.dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW {
    width: 250px !important;
  }
}
.dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW img {
    max-height: 350px !important;
  }
}
.dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .dashboard_show_box_main__SfkQx .dashboard_no_show_box__N7VeW h6 {
    font-size: 20px;
  }
}

.dashboard_attent_flex__0CP3v {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.dashboard_attent_flex__0CP3v h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.dashboard_chartsection__eiU\\+S {
  margin-top: 10px;
}

.dashboard_cardsection__sSxOq {
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0px;
}

.dashboard_cardbox1__35L3c {
  min-height: 80px;
  border-radius: 8px;
  border-color: #dbdbdb;
  padding: 22px;
  display: flex;
  margin: 0px 30px 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);
}

.dashboard_cardbox1__35L3c .dashboard_cardbox1__35L3c {
  width: 43px;
  height: 43px;
  background-color: #F3F4F8;
  min-height: unset;
  padding: 0;
  border: none;
  margin: 0;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
  color: #131F43;
  font-size: 20px;
}

#dashboard_card1bgdark__CyjLA.dashboard_cardbox1__35L3c .dashboard_cardbox1__35L3c {
  background-color: #30231a;
}

#dashboard_card1bgdark__CyjLA.dashboard_cardbox1__35L3c .dashboard_cardbox1__35L3c svg path {
  fill: #9d785f;
}

.dashboard_cardbox2__zJGHX .dashboard_cardbox2__zJGHX {
  width: 43px;
  height: 43px;
  background-color: #FAF4FB;
  min-height: unset;
  padding: 0;
  border: none;
  margin: 0;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
  color: #AC44BB;
  font-size: 20px;
}

#dashboard_card2bgdark__rY7Kf.dashboard_cardbox2__zJGHX .dashboard_cardbox2__zJGHX {
  background-color: #13252a;
}

#dashboard_card2bgdark__rY7Kf.dashboard_cardbox2__zJGHX .dashboard_cardbox2__zJGHX svg path {
  fill: #3b606a;
}

.dashboard_cardbox3__6l8x6 .dashboard_cardbox3__6l8x6 {
  width: 43px;
  height: 43px;
  background-color: #FAF7F3;
  min-height: unset;
  padding: 0;
  border: none;
  margin: 0;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
  color: #D69A5F;
  font-size: 20px;
}

#dashboard_card3bgdark__duwdO.dashboard_cardbox3__6l8x6 .dashboard_cardbox3__6l8x6 {
  background-color: #2c1a27;
}

#dashboard_card3bgdark__duwdO.dashboard_cardbox3__6l8x6 .dashboard_cardbox3__6l8x6 svg path {
  fill: #6c4863;
}

.dashboard_cardbox4__gJsOu .dashboard_cardbox4__gJsOu {
  width: 43px;
  height: 43px;
  background-color: #F5F9FC;
  min-height: unset;
  padding: 0;
  border: none;
  margin: 0;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
  color: #176CA5;
  font-size: 20px;
}

#dashboard_card4bgdark__8dScE.dashboard_cardbox4__gJsOu .dashboard_cardbox4__gJsOu {
  background-color: #241d3e;
}

#dashboard_card4bgdark__8dScE.dashboard_cardbox4__gJsOu .dashboard_cardbox4__gJsOu svg path {
  fill: #5f538b;
}

.dashboard_cardbox5__5CCAf .dashboard_cardbox5__5CCAf {
  width: 43px;
  height: 43px;
  background-color: #FAF4FB;
  min-height: unset;
  padding: 0;
  border: none;
  margin: 0;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
  color: #AC44BB;
  font-size: 20px;
}

#dashboard_card2bgdark__rY7Kf.dashboard_cardbox5__5CCAf .dashboard_cardbox5__5CCAf {
  background-color: #13252a;
}

#dashboard_card2bgdark__rY7Kf.dashboard_cardbox5__5CCAf .dashboard_cardbox5__5CCAf svg path {
  fill: #3b606a;
}

.dashboard_cardbox2__zJGHX {
  min-height: 80px;
  border-radius: 8px;
  border-color: #dbdbdb;
  padding: 22px;
  display: flex;
  margin: 0px 30px 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);
}

.dashboard_cardbox3__6l8x6 {
  min-height: 80px;
  border-radius: 8px;
  border-color: #dbdbdb;
  padding: 22px;
  display: flex;
  margin: 0px 30px 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);
}

.dashboard_cardbox4__gJsOu {
  min-height: 80px;
  border-radius: 8px;
  border-color: #dbdbdb;
  padding: 22px;
  display: flex;
  margin: 0px 0px 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);
}

.dashboard_cardbox5__5CCAf {
  min-height: 80px;
  border-radius: 8px;
  border-color: #dbdbdb;
  padding: 22px;
  display: flex;
  margin: 0px 0px 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);
}

#dashboard_chartcards__4sfid {
  height: auto;
  min-height: 275px;
  padding: 10px;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075) !important;
  border: none;
  border-radius: 10px;
  margin-bottom: 10px;
}

.dashboard_user_title__qv0\\+d {
  font-size: 22px;
  font-weight: 700;
  color: #1d1d1d;
  margin-top: 20px;
}

.dashboard_bodythemedark__tNqjU .dashboard_user_title__qv0\\+d {
  color: #fff;
}

.dashboard_angleright__09Ro- {
  margin-right: 5px;
}

.dashboard_viewall_link__tY-XZ {
  font-size: 14px;
  color: #60677e;
  text-decoration: none;
}

.dashboard_viewall_link__tY-XZ:hover {
  color: #131F43;
  border-bottom: 2px solid #131F43;
}

.dashboard_no_evnt__jcY\\+- {
  text-align: center;
  margin: 1.5%;
}

.dashboard_no_evnt__jcY\\+- img {
  max-width: 300px;
}

.dashboard_no_evnt__jcY\\+- h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}

.dashboard_no_evnt__jcY\\+- button {
  padding: 2px 20px;
  margin-top: 20px;
}

.dashboard_tablesection__bUA-3 {
  background-color: #fff;
  padding-top: -100px !important;
}

@media only screen and (max-width: 410px) {
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox4__gJsOu,
.dashboard_cardbox5__5CCAf {
    text-align: center !important;
    align-items: center;
  }
}
@media only screen and (max-width: 1200px) {
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox5__5CCAf,
.dashboard_cardbox4__gJsOu {
    width: 100% !important;
    margin: 0 1em 10px 0 !important;
  }
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox4__gJsOu,
.dashboard_cardbox5__5CCAf {
    padding: 14px;
  }
  .dashboard_cardbox1__35L3c .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX .dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6 .dashboard_cardbox3__6l8x6,
.dashboard_cardbox5__5CCAf .dashboard_cardbox5__5CCAf,
.dashboard_cardbox4__gJsOu .dashboard_cardbox4__gJsOu {
    width: 50px !important;
    height: 50px !important;
    flex-shrink: 0;
    font-size: 16px !important;
  }
  .dashboard_cardbox1__35L3c .dashboard_cardbox1__35L3c svg,
.dashboard_cardbox2__zJGHX .dashboard_cardbox2__zJGHX svg,
.dashboard_cardbox3__6l8x6 .dashboard_cardbox3__6l8x6 svg,
.dashboard_cardbox5__5CCAf .dashboard_cardbox5__5CCAf svg,
.dashboard_cardbox4__gJsOu .dashboard_cardbox4__gJsOu svg {
    width: 20px;
  }
  .dashboard_card_para__-TOvD {
    font-size: 24px;
  }
}
@media only screen and (max-width: 768px) {
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox5__5CCAf,
.dashboard_cardbox4__gJsOu {
    margin: 0 1em 10px 0 !important;
    justify-content: flex-start;
    width: 100%;
  }
  .dashboard_card_para__-TOvD {
    text-align: center !important;
  }
}
@media only screen and (max-width: 600px) {
  #dashboard_dashboardcont2__8Vn4y {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}
@media only screen and (max-width: 410px) {
  #dashboard_dashboardcont2__8Vn4y {
    padding: 20px 10px !important;
  }
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox5__5CCAf,
.dashboard_cardbox4__gJsOu {
    margin: 0 0.5em 10px 0 !important;
  }
}
@media only screen and (min-width: 1200px) {
  .dashboard_cardbox1__35L3c,
.dashboard_cardbox2__zJGHX,
.dashboard_cardbox3__6l8x6,
.dashboard_cardbox5__5CCAf,
.dashboard_cardbox4__gJsOu {
    height: 133px;
  }
}
@media only screen and (min-width: 1400px) {
  #dashboard_chartcards__4sfid {
    height: 365px;
  }
}
/* Full-area loading — same typography as PageLoader (Loading ..) */
.dashboard_loadingOverlay__1zh8B {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}

.dashboard_loadingText__fzrJF {
  font-family: "Lufga", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #736b66;
  margin: 0;
}

/* Lazy counter chunks while Suspense resolves */
.dashboard_suspenseCardFallback__pzprL {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 133px;
  min-width: 160px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ADtEF;;ACyEA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADtEF;;ACyEA;;;EAGE,yBApEoB;ADFtB;;ACyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADtEF;;ACyEA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ADpEF;;AC0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADvEF;;AC4EA;EACE,2BAAA;ADzEF;;AC4EA;EACE,yBAAA;EACA,YAAA;ADzEF;;AC6EA;EACE,YAAA;AD1EF;;AC6EA;EACE,sBA9GY;ADoCd;;AC6EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD1EF;;AC6EA;EACE,yBArIgB;EAsIhB,iBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,sBAtIY;AD4Dd;;AC6EA;EACE,yBArJgB;AD2ElB;;AC6EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBA1KgB;ADgGlB;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;EAEE,sBAAA;AD1EF;;AC6EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AD6HpB;;AC6EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;;EAEE,qBAAA;AD1EF;;AC6EA;EACE,yBArOsB;EAsOtB,WA7NY;ADmJd;;AC6EA;;CAAA;AAGA;EACE,cAjOe;ADuJjB;;AC6EA;EACE,cArOe;AD2JjB;;AC6EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AD1EF;;AC6EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AD1EF;;AC6EA;EACE,cAvPe;AD6KjB;;AC6EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AD1EF;;AC6EA;EACE,WAtQY;AD4Ld;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,oCAAA;EACA,gCAAA;AD1EF;;AC6EA;EACE,yBAzRkB;EA0RlB,WAlSY;ADwNd;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,iBAAA;AD1EF;;AC6EA;;EAEE,+BAAA;EACA,iBAAA;AD1EF;;AC6EA;EACE,sBApTY;AD0Od;AC4EE;EACE,sBAvTU;EAwTV,YAAA;AD1EJ;AC4EE;EACA,iBAAA;AD1EF;;AC+EA;EACE,0CAAA;EACA,cA/Te;ADmPjB;AC8EE;EACE,yCAAA;EACA,eAAA;AD5EJ;;ACgFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AD7EF;;ACgFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AD7EF;AC+EE;EACE,cAnWa;ADsRjB;;ACkFA;;CAAA;AAGA;EACE,yBAlXgB;ADmSlB;;ACkFA;EACE,yBAAA;EACA,yBAAA;AD/EF;;ACkFA;EACE,yBAlYoB;EAmYpB,yBAAA;AD/EF;;ACkFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EF;;ACkFA;;CAAA;AAGA;EACE,sBAtYY;ADuTd;;ACkFA;EACE,yBAlYkB;ADmTpB;;ACmFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ADmUd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA5ZY;AD4Ud;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBAraY;ADqVd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA9aY;AD8Vd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;;;;;;;;EAQE,WA7bY;AD6Wd;;ACmFA;;CAAA;AAGA;EACE,qCAAA;ADhFF;;ACmFA;EACE,cArce;ADqXjB;;ACoFA;;CAAA;AAGA;EACE,sBAAA;ADjFF;;ACoFA;EACE,yBAAA;ADjFF;;ACoFA;EACE,yBAzekB;EA0elB,WAzdY;ADwYd;;ACoFA;EACE,yBA9ekB;EA+elB,WA9dY;AD6Yd;;ACoFA;EACE,6BAAA;ADjFF;;ACoFA;EACE,2BAAA;ADjFF;;ACoFA;EACE,yBA3fkB;AD0apB;;ACoFA;EACE,yBA9fwB;AD6a1B;;ACoFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;ADjFF;;ACoFA;EACE,yBAzgBkB;ADwbpB;;ACqFA;EACE,yBAxgBgB;ADsblB;;ACqFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFF;;ACqFA;;;EAGE,oCAAA;EACA,sBAAA;ADlFF;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ADyfhB;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ADmgBhB;;ACqFA;EACE,yBAjkBY;AD+ed;;ACqFA;EACE,yBA3jBkB;ADyepB;;ACqFA;EACE,yBA9jBwB;AD4e1B;;ACqFA;EACE,cApkBiB;ADkfnB;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFF;;ACsFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ADnFF;;ACsFA;EACE,QAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ADnFF;;ACsFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACsFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ADnFF;;ACsFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ADnFF;;ACsFA;;;EAGE,oCAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACwFA;EACE,aAAA;EACA,kBAAA;ADrFF;;ACwFA;EACE,mBAAA;ADrFF;;ACwFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADrFF;;ACwFA;EACE,UAAA;ADrFF;;ACwFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AD2lBpB;;ACwFA;EACE,aAprBkB;AD+lBpB;;ACwFA;EACE,yBAhrBgB;AD2lBlB;;ACwFA;EACE,yBAAA;ADrFF;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;AD0lBd;;ACwFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;ADgmBd;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ADsmBd;;ACwFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AD2mBd;;ACwFA;;;EAGE,WAtsBY;ADinBd;;ACwFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ADunBd;;ACwFA;EACE,yBA9vBO;ADyqBT;;ACwFA;EACE,eA/tBgB;AD0oBlB;;ACwFA;EACE,YAxtBY;ADmoBd;;ACwFA;;EAEE,sBAAA;ADrFF;;ACwFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;ADzFF;;AC4FA;EACE,0BAAA;ADzFF;;AC4FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;ADzFF;;AC4FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;ADzFF;;AC4FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;ADzFF;;AC4FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;ADzFF;;AC4FA;;EAEE,0BAAA;EACA,aAAA;ADzFF;;AC4FA;EACE,kBAAA;EACA,kBAAA;ADzFF;;AC4FA;EACE;IACE,gBAAA;EDzFF;AACF;AC4FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ED1FF;EC6FA;IACE,uBAAA;IACA,+BAAA;ED3FF;AACF;AC8FA;EACE;;IAAA;AD1FF;AC+FA;EACE;IACE,uBAAA;ED7FF;ECgGA;IACE,6BAAA;ED9FF;AACF;ACiGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FF;ECkGA;;IAEE,kBAAA;EDhGF;ECmGA;IACE,eAAA;EDjGF;ECoGA;IACE,aAAA;EDlGF;ECqGA;IACE,8BAAA;IACA,aAAA;EDnGF;AACF;ACsGA;EACE;IACE,iBAAA;EDpGF;ECuGA;IACE,gBAAA;EDrGF;ECwGA;;KAAA;ADpGF;ACyGA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGJ;AC0GI;EAPF;IAQI,gBAAA;EDvGJ;AACF;AC0GE;EACE,WAAA;EACA,cAAA;ADxGJ;AC0GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ADxGN;ACyGM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDtGN;AACF;ACuGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADrGR;ACyGI;EACE,WAAA;EACA,cAAA;ADvGN;ACwGA;EACE,cAAA;ADtGF;ACwGM;EACE,WAAA;EACA,mBAAA;ADtGR;ACwGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADtGV;ACyGQ;EACE,kFAAA;ADvGV;AC4GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD1GR;AC6GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD3GR;AC6GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD3GV;AC8GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AD5GV;;ACmHA,mBAAA;AACA;EACI,2BAAA;ADhHJ;;ACmHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADhHJ;ACkHI;EATF;IAUI,yBAAA;ED/GJ;AACF;ACiHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;ED9GJ;AACF;ACiHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AD/GR;ACmHI;EACE,SAAA;ADjHN;ACmHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHR;ACmHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHR;AACF;ACkHQ;EACE,SAAA;EACA,UAAA;ADhHV;ACkHU;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GV;AACF;ACiHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GV;AACF;ACgHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9GZ;ACiHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/GZ;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACwHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ADrHJ;ACsHI;EANH;IAOK,uBAAA;EDnHJ;AACF;;ACqHA;EACE,gBAAA;ADlHF;ACoHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ADlHJ;ACoHI;EARF;IASI,kBAAA;EDjHJ;AACF;ACkHI;EAXF;IAYI,iBAAA;IACA,uBAAA;ED/GJ;AACF;ACiHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AD/GN;ACiHM;EALF;IAMI,4BAAA;ED9GN;AACF;ACiHI;EACE,4BAAA;AD/GN;ACmHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADjHJ;ACmHI;EALF;IAMI,uBAAA;EDhHJ;AACF;ACkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADhHN;ACkHM;EALF;IAMI,4BAAA;ED/GN;AACF;ACiHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AD/GN;ACgHM;EARF;IASI,eAAA;ED7GN;AACF;;ACoHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADjHF;ACmHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADjHJ;;AA3lCA;EACE,gBAAA;AA8lCF;;AA3lCA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AA8lCF;;AA5lCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EAEA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,WCkCY;EDjCZ,sDAAA;AA8lCF;;AA3lCA;EACE,WAAA;EACA,YAAA;EACA,yBCfa;EDgBb,iBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cC5Bc;ED6Bd,eAAA;AA8lCF;;AA3lCA;EACE,yBC7BiB;AD2nCnB;;AA3lCA;EACE,aChCsB;AD8nCxB;;AA3lCA;EACE,WAAA;EACA,YAAA;EACA,yBCrCa;EDsCb,iBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCtCgB;EDuChB,eAAA;AA8lCF;;AA3lCA;EACE,yBCnDiB;ADipCnB;;AA3lCA;EACE,aCtDsB;ADopCxB;;AA3lCA;EACE,WAAA;EACA,YAAA;EACA,yBC3Da;ED4Db,iBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cC9DgB;ED+DhB,eAAA;AA8lCF;;AA3lCA;EACE,yBCzEiB;ADuqCnB;;AA3lCA;EACE,aC5EsB;AD0qCxB;;AA3lCA;EACE,WAAA;EACA,YAAA;EACA,yBCjFa;EDkFb,iBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCtFgB;EDuFhB,eAAA;AA8lCF;;AA3lCA;EACE,yBC/FiB;AD6rCnB;;AA3lCA;EACE,aClGsB;ADgsCxB;;AA3lCA;EACE,WAAA;EACA,YAAA;EACA,yBChHa;EDiHb,iBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCjHgB;EDkHhB,eAAA;AA8lCF;;AA3lCA;EACE,yBC9HiB;AD4tCnB;;AA3lCA;EACE,aCjIsB;AD+tCxB;;AA3lCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EAEA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,WCzGY;ED0GZ,sDAAA;AA6lCF;;AA1lCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EAEA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,WCvHY;EDwHZ,sDAAA;AA4lCF;;AAzlCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EAEA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,WCrIY;EDsIZ,sDAAA;AA2lCF;;AAxlCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EAEA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,WCnJY;EDoJZ,sDAAA;AA0lCF;;AAvlCA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,iEAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA0lCF;;AAvlCA;EACE,eAAA;EACA,gBCrNU;EDsNV,cClKgB;EDmKhB,gBAAA;AA0lCF;;AAvlCA;EACE,WCzKY;ADmwCd;;AAvlCA;EACE,iBAAA;AA0lCF;;AAvlCA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AA0lCF;;AAvlCA;EACE,cC1KiB;ED2KjB,gCAAA;AA0lCF;;AAxlCA;EACE,kBAAA;EACA,YAAA;AA2lCF;;AAzlCA;EACE,gBAAA;AA4lCF;;AA1lCA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA6lCF;;AA3lCA;EACE,iBAAA;EACA,gBAAA;AA8lCF;;AA3lCA;EACE,sBChNY;EDiNZ,8BAAA;AA8lCF;;AA5lCA;EACE;;;;;IAKE,6BAAA;IACA,mBAAA;EA+lCF;AACF;AA7lCA;EACE;;;;;IAKE,sBAAA;IACA,+BAAA;EA+lCF;EA7lCA;;;;;IAKE,aAAA;EA+lCF;EA7lCA;;;;;IAKE,sBAAA;IACA,uBAAA;IACA,cAAA;IACA,0BAAA;EA+lCF;EA7lCA;;;;;IAKE,WAAA;EA+lCF;EA7lCA;IACE,eAAA;EA+lCF;AACF;AA5lCA;EACE;;;;;IAKE,+BAAA;IACA,2BAAA;IACA,WAAA;EA8lCF;EA5lCA;IACE,6BAAA;EA8lCF;AACF;AA3lCA;EACE;IACE,wBCtPQ;IDuPR,UCtPO;IDuPP,kBAAA;IACA,aC9Pe;ED21CjB;AACF;AA1lCA;EACE;IACE,6BAAA;EA4lCF;EAzlCA;;;;;IAKE,iCAAA;EA2lCF;AACF;AAxlCA;EACE;;;;;IAKE,aAAA;EA0lCF;AACF;AAvlCA;EACE;IACE,aAAA;EAylCF;AACF;AAtlCA,mEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AAwlCF;;AArlCA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAwlCF;;AArlCA,gDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAwlCF","sourcesContent":["@import '/src/styles/Variables/Variables.scss';\n\n.chartsection {\n  margin-top: 10px;\n}\n\n.cardsection {\n  padding: 0px;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0px;\n}\n.cardbox1 {\n  min-height: 80px;\n  border-radius: 8px;\n  border-color: #dbdbdb;\n  padding: 22px;\n  display: flex;\n  // display: inline-block;\n  margin: 0px 30px 20px 0;\n  width: 100%;\n  text-align: left;\n  color: $white-color;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);\n}\n\n.cardbox1 .cardbox1 {\n  width: 43px;\n  height: 43px;\n  background-color: $cardIcon1-bg;\n  min-height: unset;\n  padding: 0;\n  border: none;\n  margin: 0;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  margin-right: 10px;\n  color: $primary-color;\n  font-size: 20px;\n}\n\n#card1bgdark.cardbox1 .cardbox1 {\n  background-color: $cardIcon1-darkbg;\n}\n\n#card1bgdark.cardbox1 .cardbox1 svg path {\n  fill: $cardIcon1-darkbg-icon;\n}\n\n.cardbox2 .cardbox2 {\n  width: 43px;\n  height: 43px;\n  background-color: $cardIcon2-bg;\n  min-height: unset;\n  padding: 0;\n  border: none;\n  margin: 0;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  margin-right: 10px;\n  color: $cardIcon2-color;\n  font-size: 20px;\n}\n\n#card2bgdark.cardbox2 .cardbox2 {\n  background-color: $cardIcon2-darkbg;\n}\n\n#card2bgdark.cardbox2 .cardbox2 svg path {\n  fill: $cardIcon2-darkbg-icon;\n}\n\n.cardbox3 .cardbox3 {\n  width: 43px;\n  height: 43px;\n  background-color: $cardIcon3-bg;\n  min-height: unset;\n  padding: 0;\n  border: none;\n  margin: 0;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  margin-right: 10px;\n  color: $cardIcon3-color;\n  font-size: 20px;\n}\n\n#card3bgdark.cardbox3 .cardbox3 {\n  background-color: $cardIcon3-darkbg;\n}\n\n#card3bgdark.cardbox3 .cardbox3 svg path {\n  fill: $cardIcon3-darkbg-icon;\n}\n\n.cardbox4 .cardbox4 {\n  width: 43px;\n  height: 43px;\n  background-color: $cardIcon4-bg;\n  min-height: unset;\n  padding: 0;\n  border: none;\n  margin: 0;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  margin-right: 10px;\n  color: $cardIcon4-color;\n  font-size: 20px;\n}\n\n#card4bgdark.cardbox4 .cardbox4 {\n  background-color: $cardIcon4-darkbg;\n}\n\n#card4bgdark.cardbox4 .cardbox4 svg path {\n  fill: $cardIcon4-darkbg-icon;\n}\n\n.cardbox5 .cardbox5 {\n  width: 43px;\n  height: 43px;\n  background-color: $cardIcon2-bg;\n  min-height: unset;\n  padding: 0;\n  border: none;\n  margin: 0;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  margin-right: 10px;\n  color: $cardIcon2-color;\n  font-size: 20px;\n}\n\n#card2bgdark.cardbox5 .cardbox5 {\n  background-color: $cardIcon2-darkbg;\n}\n\n#card2bgdark.cardbox5 .cardbox5 svg path {\n  fill: $cardIcon2-darkbg-icon;\n}\n\n.cardbox2 {\n  min-height: 80px;\n  border-radius: 8px;\n  border-color: #dbdbdb;\n  padding: 22px;\n  display: flex;\n  // display: inline-block;\n  margin: 0px 30px 20px 0;\n  width: 100%;\n  text-align: left;\n  color: $white-color;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);\n}\n\n.cardbox3 {\n  min-height: 80px;\n  border-radius: 8px;\n  border-color: #dbdbdb;\n  padding: 22px;\n  display: flex;\n  // display: inline-block;\n  margin: 0px 30px 20px 0;\n  width: 100%;\n  text-align: left;\n  color: $white-color;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);\n}\n\n.cardbox4 {\n  min-height: 80px;\n  border-radius: 8px;\n  border-color: #dbdbdb;\n  padding: 22px;\n  display: flex;\n  // display: inline-block;\n  margin: 0px 0px 20px 0;\n  width: 100%;\n  text-align: left;\n  color: $white-color;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);\n}\n\n.cardbox5 {\n  min-height: 80px;\n  border-radius: 8px;\n  border-color: #dbdbdb;\n  padding: 22px;\n  display: flex;\n  // display: inline-block;\n  margin: 0px 0px 20px 0;\n  width: 100%;\n  text-align: left;\n  color: $white-color;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075);\n}\n\n#chartcards {\n  height: auto;\n  min-height: 275px;\n  padding: 10px;\n  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.075) !important;\n  border: none;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.user_title {\n  font-size: 22px;\n  font-weight: $font-bold;\n  color: $fullBlack-color;\n  margin-top: 20px;\n}\n\n.bodythemedark .user_title {\n  color: $white-color;\n}\n\n.angleright {\n  margin-right: 5px;\n}\n\n.viewall_link {\n  font-size: 14px;\n  color: #60677e;\n  text-decoration: none;\n}\n\n.viewall_link:hover {\n  color: $primary-btncolor;\n  border-bottom: 2px solid $primary-btncolor;\n}\n.no_evnt {\n  text-align: center;\n  margin: 1.5%;\n}\n.no_evnt img {\n  max-width: 300px;\n}\n.no_evnt h6 {\n  color: #000;\n  text-align: center;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-top: 20px;\n}\n.no_evnt button {\n  padding: 2px 20px;\n  margin-top: 20px;\n}\n\n.tablesection {\n  background-color: $white-color;\n  padding-top: -100px !important;\n}\n@media only screen and (max-width: 410px) {\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox4,\n  .cardbox5 {\n    text-align: center !important;\n    align-items: center;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox5,\n  .cardbox4 {\n    width: 100% !important;\n    margin: 0 1em 10px 0 !important;\n  }\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox4,\n  .cardbox5 {\n    padding: 14px;\n  }\n  .cardbox1 .cardbox1,\n  .cardbox2 .cardbox2,\n  .cardbox3 .cardbox3,\n  .cardbox5 .cardbox5,\n  .cardbox4 .cardbox4 {\n    width: 50px !important;\n    height: 50px !important;\n    flex-shrink: 0;\n    font-size: 16px !important;\n  }\n  .cardbox1 .cardbox1 svg,\n  .cardbox2 .cardbox2 svg,\n  .cardbox3 .cardbox3 svg,\n  .cardbox5 .cardbox5 svg,\n  .cardbox4 .cardbox4 svg {\n    width: 20px;\n  }\n  .card_para {\n    font-size: 24px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox5,\n  .cardbox4 {\n    margin: 0 1em 10px 0 !important;\n    justify-content: flex-start;\n    width: 100%;\n  }\n  .card_para {\n    text-align: center !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  #dashboardcont2 {\n    width: $dashwidth;\n    left: $dashleft;\n    position: relative;\n    padding: $dashboardpadding;\n  }\n}\n\n@media only screen and (max-width: 410px) {\n  #dashboardcont2 {\n    padding: 20px 10px !important;\n  }\n\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox5,\n  .cardbox4 {\n    margin: 0 0.5em 10px 0 !important;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .cardbox1,\n  .cardbox2,\n  .cardbox3,\n  .cardbox5,\n  .cardbox4 {\n    height: 133px;\n  }\n}\n\n@media only screen and (min-width: 1400px) {\n  #chartcards {\n    height: 365px;\n  }\n}\n\n/* Full-area loading — same typography as PageLoader (Loading ..) */\n.loadingOverlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.loadingText {\n  font-family: 'Lufga', 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #736b66;\n  margin: 0;\n}\n\n/* Lazy counter chunks while Suspense resolves */\n.suspenseCardFallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 133px;\n  min-width: 160px;\n}\n","/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `dashboard_dashboard__2X4pa`,
	"dashboardContain": `dashboard_dashboardContain__1PN1x`,
	"bodythemedark": `dashboard_bodythemedark__tNqjU`,
	"cont2": `dashboard_cont2__JTzw+`,
	"top_header": `dashboard_top_header__7yObV`,
	"top_header_inner": `dashboard_top_header_inner__jX0wl`,
	"subLink": `dashboard_subLink__1mmvU`,
	"cst_vendr": `dashboard_cst_vendr__HfXMV`,
	"form-control": `dashboard_form-control__bgAMo`,
	"footer": `dashboard_footer__KnaRi`,
	"bodythemelight": `dashboard_bodythemelight__85mlL`,
	"bodythemeNew": `dashboard_bodythemeNew__zmUcj`,
	"headerthemelight": `dashboard_headerthemelight__DdGpF`,
	"headerthemedark": `dashboard_headerthemedark__2fO1i`,
	"menuthemelight": `dashboard_menuthemelight__dLcQx`,
	"menuthemedark": `dashboard_menuthemedark__z3mbP`,
	"menulinklight": `dashboard_menulinklight__QWbE3`,
	"menulinkdarkSelected": `dashboard_menulinkdarkSelected__UpGSV`,
	"menulinklightSelected": `dashboard_menulinklightSelected__uaXyO`,
	"menulinkdark": `dashboard_menulinkdark__jiiRQ`,
	"sub_arrow": `dashboard_sub_arrow__poJaq`,
	"headinglight": `dashboard_headinglight__8Gl0v`,
	"headingdark": `dashboard_headingdark__X4j2I`,
	"searchboxlight": `dashboard_searchboxlight__A7x-y`,
	"searchboxdark": `dashboard_searchboxdark__GuhA+`,
	"tableheadlight": `dashboard_tableheadlight__VLx7S`,
	"tableheaddark": `dashboard_tableheaddark__odkCt`,
	"table": `dashboard_table__zohyZ`,
	"table-borderless": `dashboard_table-borderless__cL77O`,
	"left-section": `dashboard_left-section__4nEtb`,
	"tablebodylight": `dashboard_tablebodylight__xtFsA`,
	"tablebodydark": `dashboard_tablebodydark__5Jm0I`,
	"paginationlight": `dashboard_paginationlight__O9iTx`,
	"paginationdark": `dashboard_paginationdark__6A2kS`,
	"formthemelight": `dashboard_formthemelight__BpAw2`,
	"formthemedark": `dashboard_formthemedark__qFGY5`,
	"viewformlight": `dashboard_viewformlight__67llm`,
	"permissionboxlight": `dashboard_permissionboxlight__k6c2l`,
	"permissionboxdark": `dashboard_permissionboxdark__MoLbm`,
	"errormsgclr": `dashboard_errormsgclr__7ulBC`,
	"graphclrlight": `dashboard_graphclrlight__qWxEk`,
	"graphclrdark": `dashboard_graphclrdark__D1mje`,
	"card1bglight": `dashboard_card1bglight__wOTeF`,
	"card1bgdark": `dashboard_card1bgdark__CyjLA`,
	"card2bglight": `dashboard_card2bglight__9gJ+Q`,
	"card2bgdark": `dashboard_card2bgdark__rY7Kf`,
	"card3bglight": `dashboard_card3bglight__AcfyJ`,
	"card3bgdark": `dashboard_card3bgdark__duwdO`,
	"card4bglight": `dashboard_card4bglight__L0oy1`,
	"card4bgdark": `dashboard_card4bgdark__8dScE`,
	"actionbtnlight": `dashboard_actionbtnlight__OV3fZ`,
	"actionbtndark": `dashboard_actionbtndark__Ym9uB`,
	"profiledropdownlight": `dashboard_profiledropdownlight__DeK28`,
	"profiledropdowndark": `dashboard_profiledropdowndark__H2uVI`,
	"settingsection": `dashboard_settingsection__kqMt9`,
	"addform": `dashboard_addform__1o+ax`,
	"savebtn": `dashboard_savebtn__S908b`,
	"profile_conatiner": `dashboard_profile_conatiner__6npgU`,
	"ag-theme-alpine": `dashboard_ag-theme-alpine__z7eG5`,
	"ag-row": `dashboard_ag-row__AN4Wr`,
	"formbtn": `dashboard_formbtn__4fnEY`,
	"resetbtn": `dashboard_resetbtn__ZiZhn`,
	"addBtn": `dashboard_addBtn__tARHS`,
	"addDltBtn": `dashboard_addDltBtn__dsT6F`,
	"addbtnlight": `dashboard_addbtnlight__Y6MkE`,
	"addbtndark": `dashboard_addbtndark__DLUUQ`,
	"cust_addBtn": `dashboard_cust_addBtn__JN2C2`,
	"deleteBtn": `dashboard_deleteBtn__1orlI`,
	"confirmBtn": `dashboard_confirmBtn__Aj0HH`,
	"delPopContainer": `dashboard_delPopContainer__bRFtb`,
	"modal-body": `dashboard_modal-body__pICNd`,
	"delet_icon": `dashboard_delet_icon__79xF7`,
	"arrowback": `dashboard_arrowback__74CQ1`,
	"drpdwn_btn": `dashboard_drpdwn_btn__L8wHP`,
	"empname": `dashboard_empname__mqYmp`,
	"navitemli": `dashboard_navitemli__t6lEK`,
	"tabnavli": `dashboard_tabnavli__HzoDT`,
	"settingsgeneral": `dashboard_settingsgeneral__YZDSd`,
	"settingslinks": `dashboard_settingslinks__MpNF6`,
	"dropdown_menu_contain": `dashboard_dropdown_menu_contain__8MeLG`,
	"dropdown_item": `dashboard_dropdown_item__JKrCf`,
	"profile_arrrow_dwn": `dashboard_profile_arrrow_dwn__zj21K`,
	"dateinputbox1": `dashboard_dateinputbox1__UEice`,
	"modal-content": `dashboard_modal-content__8gJsZ`,
	"larg_model": `dashboard_larg_model__GfhPs`,
	"modal-dialog": `dashboard_modal-dialog__6Mq2P`,
	"modal-header": `dashboard_modal-header__3Zdve`,
	"btn-primary": `dashboard_btn-primary__0X7d8`,
	"form-select": `dashboard_form-select__M5y6t`,
	"CustomTable_tableheadlight__HuHZw": `dashboard_CustomTable_tableheadlight__HuHZw__IF0OD`,
	"CustomTable_tableheaddark__nwqb4": `dashboard_CustomTable_tableheaddark__nwqb4__38ezU`,
	"sectionright": `dashboard_sectionright__+CbsA`,
	"exer_modal_contain": `dashboard_exer_modal_contain__LM7JH`,
	"active_show_outer": `dashboard_active_show_outer__B2-gQ`,
	"active_show_inner": `dashboard_active_show_inner__7pO90`,
	"act_box_img": `dashboard_act_box_img__yaAM1`,
	"act_box_cnt": `dashboard_act_box_cnt__0wa8Q`,
	"act_box_bdg": `dashboard_act_box_bdg__jdTPH`,
	"sold": `dashboard_sold__w3d+y`,
	"timezone_code_pill": `dashboard_timezone_code_pill__b-aV2`,
	"attent_details_row1": `dashboard_attent_details_row1__+ZT33`,
	"attent_details": `dashboard_attent_details__mNmuQ`,
	"attent_details_inner": `dashboard_attent_details_inner__EfTNs`,
	"attent_details_inner_l": `dashboard_attent_details_inner_l__aLxIj`,
	"attent_details_inner_r": `dashboard_attent_details_inner_r__QqrY1`,
	"attent_details_row": `dashboard_attent_details_row__oIfeE`,
	"attent_details_row_box": `dashboard_attent_details_row_box__2R8iC`,
	"attent_details_row_last": `dashboard_attent_details_row_last__rzty5`,
	"interesting_fact": `dashboard_interesting_fact__t+aAo`,
	"showbox_sec": `dashboard_showbox_sec__-3t21`,
	"show_box_main": `dashboard_show_box_main__SfkQx`,
	"show_box": `dashboard_show_box__6V0g+`,
	"no_show_box": `dashboard_no_show_box__N7VeW`,
	"attent_flex": `dashboard_attent_flex__0CP3v`,
	"chartsection": `dashboard_chartsection__eiU+S`,
	"cardsection": `dashboard_cardsection__sSxOq`,
	"cardbox1": `dashboard_cardbox1__35L3c`,
	"cardbox2": `dashboard_cardbox2__zJGHX`,
	"cardbox3": `dashboard_cardbox3__6l8x6`,
	"cardbox4": `dashboard_cardbox4__gJsOu`,
	"cardbox5": `dashboard_cardbox5__5CCAf`,
	"chartcards": `dashboard_chartcards__4sfid`,
	"user_title": `dashboard_user_title__qv0+d`,
	"angleright": `dashboard_angleright__09Ro-`,
	"viewall_link": `dashboard_viewall_link__tY-XZ`,
	"no_evnt": `dashboard_no_evnt__jcY+-`,
	"tablesection": `dashboard_tablesection__bUA-3`,
	"card_para": `dashboard_card_para__-TOvD`,
	"dashboardcont2": `dashboard_dashboardcont2__8Vn4y`,
	"loadingOverlay": `dashboard_loadingOverlay__1zh8B`,
	"loadingText": `dashboard_loadingText__fzrJF`,
	"suspenseCardFallback": `dashboard_suspenseCardFallback__pzprL`
};
export default ___CSS_LOADER_EXPORT___;
